import { render, staticRenderFns } from "./userPicture.vue?vue&type=template&id=b611d21a&"
import script from "./userPicture.vue?vue&type=script&lang=js&"
export * from "./userPicture.vue?vue&type=script&lang=js&"
import style0 from "./userPicture.vue?vue&type=style&index=0&id=b611d21a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports